import { inject, Injectable, signal } from '@angular/core';
import { UserService } from './user.service';
import { PING_INTERVAL } from '../config/constants';

@Injectable({ providedIn: 'root' })
export class TimerControlService {
  public startSignal = signal(false);
  public stopSignal = signal(false);
  public resetSignal = signal(false);
  public isPingTimerRunning = signal<boolean>(false);
  public startCountdownSignal = signal(false);
  public stopCountdownSignal = signal(false);
  public resetCountdownSignal = signal(false);
  private userService = inject(UserService);

  private pingTimer: ReturnType<typeof setInterval> | undefined = undefined;

  /**
   * Resets all timer control signals
   */
  resetAllSignals(): void {
    this.startSignal.set(false);
    this.stopSignal.set(false);
    this.resetSignal.set(false);
    this.startCountdownSignal.set(false);
    this.stopCountdownSignal.set(false);
    this.resetCountdownSignal.set(false);
  }

  /**
   * Starts the ping timer to automatically ping the backend at regular intervals
   */
  startPingTimer(): void {
    if (this.isPingTimerRunning()) {
      return;
    }

    this.isPingTimerRunning.set(true);
    this.userService.pingBackend();
    this.pingTimer = setInterval(() => {
      this.userService.pingBackend();
    }, PING_INTERVAL);
  }

  /**
   * Stops the ping timer
   */
  stopPingTimer(): void {
    if (!this.isPingTimerRunning()) {
      return;
    }
    clearInterval(this.pingTimer);
    this.pingTimer = undefined;
    this.isPingTimerRunning.set(false);
  }

  startCountdown(): void {
    this.startCountdownSignal.set(true);
  }

  stopCountdown(): void {
    this.stopCountdownSignal.set(true);
  }

  resetCountdown(): void {
    this.resetCountdownSignal.set(true);
  }
}
